import { useEffect, useState } from "react"
import ReactFlow, {MiniMap,  Controls, useStoreActions, isNode, isEdge } from 'react-flow-renderer';
import { uuid } from "../HelperFunctions";
import { useClipboard } from "./useClipboard";


export const usePropsClipboard = () => {

  const { supportClipboardRead, supportClipboardWrite, getTextFromClipboard, copyTextToClipboard } = useClipboard();

  const copyPropsFromFmk = ({fmk, copyProps = []}) => {
    const toClipboard = JSON.stringify({
      type:"props", 
      props: resolveCopyProps(fmk.values, copyProps),
      id: uuid()
    });
    copyTextToClipboard(toClipboard);
  }

  const resolveCopyProps = (values, copyProps) => {
    console.log({copyProps, values})
    if(typeof copyProps === "object" && Array.isArray(copyProps)) {
      return Object.keys(values).reduce((prev, key)=>{
        if(copyProps.length == 0 || copyProps.some(k => k === key)){
          return {...prev, [key]: values[key]};
        }else{
          return prev;
        }
      }, {})
    }
    if(typeof copyProps === "object") {
      return Object.keys(values).reduce((prev, key)=>{
        if(!!copyProps[key]){
          return {...prev, [key]: copyProps[key](values[key])};
        }else{
          return prev;
        }
      }, {})
    }
  }

  const pastePropsIntoFmk = ({fmk, pasteProps = []}) => new Promise((resolve, reject)=>{
    getProps()
      .then(result => {
        console.log({result})
        const values = fmk.values;
        const props = result.props;
        const newValues = resolvePasteProps(props, values, pasteProps);
        fmk.setValues(newValues);
        resolve();
      })
      .catch(err => {
        reject();
        console.log(err);
      })
  })

  const getProps = () => new Promise((resolve, reject) => {
    getTextFromClipboard()
      .then(text => {
          propsFromText(text)
            .then(props => {
              console.log(props)
              resolve(props);
            })        
            .catch(reason => {
              reject(reason);
            });
        })
      .catch(reason => {
        reject(reason);
      });
  })

  
  const propsFromText = (text) => new Promise((resolve, reject)=>{
    try{
      const result = JSON.parse(text);
      if(result.type==="props" && result.props && result.id){
        resolve(result);
      }else{
        reject("es un json pero no son propiedades");
      }
    }catch(e){
      reject("no es un json");
    }
  });

  const resolvePasteProps = (props, values, pasteProps) => {
    if(typeof pasteProps === "object" && Array.isArray(pasteProps)) {
      return Object.keys(props).reduce((prev, key)=>{
        return (props[key] !== undefined && (pasteProps.length === 0 || pasteProps.some(k => k === key)))
          ? {...prev, [key]: props[key]}
          : prev;
      }, values);    
    }
    if(typeof pasteProps === "object") {
      return Object.keys(props).reduce((prev, key)=>{
        return (props[key] !== undefined && !!pasteProps[key])
          ? {...prev, [key]: pasteProps[key](props[key], values[key])}
          : prev;
      }, values);    
    }
  }

  return {copyPropsFromFmk, pastePropsIntoFmk};

}
